/*This file contains all of the global filters for the OCI web application.
* Import filters.js to make all filters contained herein accessible*/

import Vue from 'vue'
import moment from 'moment'

Vue.filter('ociPercentage', value => {
  if(!value){
    return 0;
  }
  let val = (value/1).toFixed(1).replace(',', '.');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});


/*OCI Standard filter for dates
* rawDate - A js Date object
* return - Date in format DD/MM/YYYY
* */
Vue.filter('ociDate', rawDate => {
  rawDate = new Date(rawDate);
  return moment.utc(rawDate).format("MMM-DD-YYYY")
});

/*OCI Standard filter for timestamp
* rawDate - A js Date object
* return - Date in format DD/MM/YYYY h:mm a
* */
Vue.filter('ociTimestamp', rawDate =>
{
  rawDate = new Date(rawDate);
  return moment.utc(rawDate).format("MMM-DD-YYYY h:mm a");
});

/*OCI Standard filter for date and time
* rawDate - A js Date object
* return - Date in format DD/MM h:mm a
* */
Vue.filter('ociDateTime', rawDate =>
{
  rawDate = new Date(rawDate);
  return moment(rawDate).format("MMM-DD h:mm a");
});
Vue.filter('ociDateTimeEpoch', epoch =>
{
  var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
  d.setUTCSeconds(epoch);
  let date = new Date(d);
  if(moment(date).format("yyyy") < moment(new Date()).format("yyyy")){
    return moment(date).format("MMM DD, YY h:mm a")
  }
  if(new Date(date.toDateString()) < new Date(new Date().toDateString())){
    return moment(date).format("MMM DD h:mm a")
  }
  return moment(date).format("h:mm a");
});


/*OCI Standard filter for phone numbers
* s - A 10 digit phone number
* return - Phone number in format '(xxx) xxx-xxxx'
* */
Vue.filter('ociPhone', s => {
  var s2 = (""+s).replace(/\D/g, '');
  var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
});

Vue.filter('phone', function (phone) {
  if (phone) {
    return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  } else {
    return null
  }
});

Vue.filter('ociEmail', function (email) {
  if (email) {
    return email.replace(/[a-zA-Z@.!#$%&'*+-/=?^_`{|}~0-9]{0,150}/, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  } else {
    return null
  }
});

/*OCI Standard filter for SINs
* rawSIN - 9 digit SIN
* return - SIN in format 'xxx-xxx-xxx'
* */
Vue.filter('ociSIN', rawSIN => {
  var m = rawSIN.match(/^(\d{3})(\d{3})(\d{3})$/);
  return (!m) ? null : m[1] + "-" + m[2] + "-" + m[3];
});

/*OCI Standard filter for numerical values
* rawNumber - number to filter
* mod - quantity to apply modulo operator on rawNumber with
* return - rawNumber with some remainder portion subtracted
* */
Vue.filter('ociNumber', (rawNumber, mod = 10) => {
  return(rawNumber - (rawNumber%mod));
});

Vue.filter('ociInteger', value => {
  let val = (value/1).toFixed(0).replace(',', '.');
  return val.toString();
});

/*OCI Standard filter for currencies
* value - Some number to convert to a currency format
* return - value converted to a currency, no dollar sign ('$') added
* */
Vue.filter('ociCurrency', value => {
  if(!value){
    return 0;
  }
  let val = (value/1).toFixed(2).replace(',', '.');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter('ociCurrencyNoDecimal', value => {
  let val = (value/1).toFixed(0).replace(',', '.');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter('currency', {
  read: function (value) {
    return '$' + value.toFixed(2)
  },
  write: function (value) {
    var number = +value.replace(/[^\d.]/g, '')
    return isNaN(number) ? 0 : number
  }
})

/*OCI Standard filter for postal codes
* string - A Canadian postal code, with or without a space between first and last 3 characters
* return - A Canadian postal code with a space between first and last 3 characters*/
Vue.filter('ociPostalCode', string => {
  var m = string.match(/^(\D\d\D)(\d\D\d)$/);
  this.ociLog(m);
  return (!m) ? null : m[1] + " " + m[2];
});
